// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fail-detail {
  display: inline;
  font-size: 13px;
  border-bottom: 1px dotted;
  margin: 0 auto;
}
.ant-tooltip-inner {
  border-radius: 15px;
  text-align: center;
}
.icon {
  font-size: 26px;
}
.btn-time-inactive {
  background-color: #999;
  cursor: default;
}
.btn-time-inactive:hover,
.btn-time-inactive:focus {
  background-color: #999;
}
.beey-grey {
  color: #999;
}
`, "",{"version":3,"sources":["webpack://./src/components/TableStatus/style.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AACF;AAEA;EACE,mBAAA;EACA,kBAAA;AAAF;AAEA;EACE,eAAA;AAAF;AAEA;EACE,sBAAA;EAKA,eAAA;AAJF;AAAE;;EAEE,sBAAA;AAEJ;AAGA;EACE,WAAA;AADF","sourcesContent":[".fail-detail {\n  display: inline;\n  font-size: @font-size-sm;\n  border-bottom: 1px dotted;\n  margin: 0 auto;\n}\n\n.ant-tooltip-inner {\n  border-radius: 15px;\n  text-align: center;\n}\n.icon {\n  font-size: 26px;\n}\n.btn-time-inactive {\n  background-color: @text-primary-disabled;\n  &:hover,\n  &:focus {\n    background-color: @text-primary-disabled;\n  }\n  cursor: default;\n}\n\n.beey-grey {\n  color: @text-primary-disabled;\n}\n\n@display-sm: ~\"only screen and (min-width:576px) \";@display-md: ~\"only screen and (min-width:768px)\";@display-lg: ~\"only screen and (min-width:992px)\";@display-xl: ~\"only screen and (min-width:1200px)\";@display-xxl: ~\"only screen and (min-width:1680px)\";@font-family: 'Open Sans', sans-serif;@font-size-base: 15px;@font-size-lg: @font-size-base + 2px;@font-size-sm: @font-size-base - 2px;@white: #fff;@beey-orange: #f3ab58;@beey-orange-darken: #f29f40;@beey-yellow-light: #fef9e9;@beey-blue: #698efc;@beey-blue-light: #82a1fc;@primary-color: @beey-orange-darken;@link-color: @beey-orange-darken;@text-color: #444;@text-color-secondary: #888;@heading-color: #303030;@header-height: 5rem;@header-height-sm: 3rem;@header-line-height: 2rem;@playback-height: 65px;@color-error: #95190c;@text-primary-disabled: #999;@text-secondary: #000000;@text-secondary-dimmed: #666;@text-heading1: #000000;@font-weight-semi-bold: 600;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
